import React from 'react';
import { t } from '../../i18n';
import { Link } from 'react-router-dom';

function formatPrice(price) {
  const n = Number(price);
  if (n >= 10000000) return `${(n / 10000000).toFixed(2)} Crore`;
  if (n >= 100000) return `${(n / 100000).toFixed(2)} Lakh`;
  return n.toLocaleString();
}

export default function RealtyPropertyCard({ property, onToggleCompare, isCompareChecked }) {
  const p = property;
  return (
    <div className="card" style={{ position: 'relative' }}>
      {onToggleCompare && (
        <label
          onClick={(e) => e.stopPropagation()}
          style={{ position: 'absolute', top: 10, right: 10, zIndex: 5, background: '#fff', borderRadius: 6, padding: '3px 8px', display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, boxShadow: '0 2px 6px rgba(0,0,0,0.15)', cursor: 'pointer' }}
        >
          <input type="checkbox" checked={!!isCompareChecked} onChange={() => onToggleCompare(p.id)} />
          Compare
        </label>
      )}
      <Link to={`/realty/property/${p.id}`} style={{ display: 'block' }}>
        <div className="card-img">
          <span className={`yard-tag ${p.purpose === 'rent' ? 'rent' : ''}`}>
            For {p.purpose === 'rent' ? 'Rent' : 'Sale'}
          </span>
          {p.is_featured && <span className="featured-badge">{t('featured_badge')}</span>}
          {p.cover_image ? (
            <img src={p.cover_image} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          ) : (
            'No photo yet'
          )}
        </div>
        <div className="card-body">
          <div className="card-price">
            Rs {formatPrice(p.price)}{p.purpose === 'rent' ? ' / month' : ''}
          </div>
          <div className="card-title">{p.title}</div>
          <div className="card-loc">{p.area}, {p.city}</div>
          <div className="card-specs">
            <span>{p.area_size} {p.area_unit}</span>
            {p.bedrooms != null && <span>{p.bedrooms} Bed</span>}
            {p.bathrooms != null && <span>{p.bathrooms} Bath</span>}
          </div>
        </div>
      </Link>
    </div>
  );
}
